export enum WeightMetric {
  Gram = 'weightMetricGram',
  KiloGram = 'weightMetricKiloGram',
  Tonne = 'weightMetricTonne',
  KiloTonne = 'weightMetricKiloTonne',
  MegaTonne = 'weightMetricMegaTonne',
  GigaTonne = 'weightMetricGigaTonne',
}
